import { SelectOutlined } from '@amelio/ui-library';

import type { FrequencyValue } from '@/constants/Frequency';

import { FormField } from '@/components/FormField/FormField';
import { useAmelioTranslations } from '@/hooks';
import {
    CYCLE_FIELD_IDLE_BORDER,
    CYCLE_FIELD_LABEL,
} from '@/pages/CycleEvaluation/components/cycleFieldChrome';
import { getFrequencyOptions } from '@/utils/frequency';

export interface CycleRecurrenceProps {
    frequency?: FrequencyValue;
    errorMessage?: string;
    isReadOnly?: boolean;
    onChange: (frequency: FrequencyValue) => void;
}

export const CycleRecurrence = ({
    frequency,
    errorMessage,
    isReadOnly = false,
    onChange,
}: CycleRecurrenceProps) => {
    const { t } = useAmelioTranslations();

    const label = t('cycleEvaluationSchedule.schedulingOptions.feedbackFrequency');
    const hasRecurrenceError = Boolean(errorMessage);

    return (
        <FormField
            {...CYCLE_FIELD_LABEL}
            label={label}
            errorMessage={errorMessage}
            className={'min-w-0'}
            dataTestId={'deadlines-recurrence'}
        >
            <SelectOutlined
                options={getFrequencyOptions()}
                value={frequency}
                placeholder={t('common.select')}
                readOnly={isReadOnly}
                error={hasRecurrenceError}
                onChange={(value) => onChange(value as FrequencyValue)}
                size={'mdPlus'}
                triggerBorderClassName={
                    hasRecurrenceError ? undefined : `border ${CYCLE_FIELD_IDLE_BORDER}`
                }
                triggerHoverBorderClassName={'hover:border-primary'}
                sort={'none'}
                ariaLabel={label}
                dataTestId={'deadlines-recurrence-select'}
            />
        </FormField>
    );
};
